"use client";
import { useState } from "react";
const faqs = [
    {
        question: "What conditions are treated under Brain & Spine Surgery?",
        answer: "Brain & spine surgery covers conditions such as brain tumors, stroke, head injuries, slip disc, spinal stenosis, scoliosis, spine fractures, and nerve-related disorders. Early diagnosis and expert care are essential for effective treatment.",
    },
    {
        question: "When should I consult a neurosurgeon or spine specialist in Patna?",
        answer: "You should consult a specialist if you experience persistent back or neck pain, numbness, weakness in limbs, frequent headaches, loss of balance, or any head/spine injury.",
    },
    {
        question: "Is spine surgery always required for back pain?",
        answer: "No, most spine problems can be treated with medication, physiotherapy, and lifestyle changes. Surgery is recommended only in severe cases where non-surgical treatments do not provide relief.",
    },
    {
        question: "What is minimally invasive spine surgery?",
        answer: "Minimally invasive spine surgery is an advanced technique that uses small incisions, resulting in less pain, reduced blood loss, shorter hospital stay, and faster recovery compared to traditional surgery.",
    },
    {
        question: "How risky is brain surgery?",
        answer: "Brain surgery is a complex procedure, but with modern technology, experienced neurosurgeons, and advanced monitoring systems, the risks are significantly reduced and outcomes are highly improved.",
    },
    {
        question: "How long does recovery take after spine surgery?",
        answer: "Recovery time varies depending on the type of surgery and patient condition. Minimally invasive procedures may allow recovery within a few weeks, while complex surgeries may take longer.",
    },
    {
        question: "What are the symptoms of a slipped disc?",
        answer: "Common symptoms include lower back pain, pain radiating to legs, numbness, tingling sensation, and muscle weakness. Early treatment can prevent complications.",
    },
    {
        question: "Do you provide emergency brain and spine care in Patna?",
        answer: "Yes, 24×7 emergency services are available for stroke, head injuries, spine trauma, and other critical neurological conditions requiring immediate medical attention.",
    },
    {
        question: "What diagnostic tests are used before brain or spine surgery?",
        answer: "Doctors may recommend MRI, CT scans, X-rays, and neurological assessments to accurately diagnose the condition and plan the treatment.",
    },
    {
        question: "How do I choose the best hospital for brain & spine surgery in Patna?",
        answer: "Look for experienced neurosurgeons, advanced technology, emergency support, patient reviews, and a hospital that offers complete care including diagnosis, surgery, and rehabilitation.",
    },
];
export default function FaqSection() {
    const [activeIndex, setActiveIndex] = useState(null);
    const leftFaqs = faqs.slice(0, 5);
    const rightFaqs = faqs.slice(5, 10);
    const toggleFaq = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const renderFaqs = (faqList, offset) =>
        faqList.map((faq, index) => {
            const currentIndex = index + offset;
            return (
                <div key={currentIndex} className="faq-box" onClick={() => toggleFaq(currentIndex)} >
                    {/* Question */}
                    <div className={`faq-question ${activeIndex === currentIndex ? "active" : ""}`}>
                        <h6>{faq.question}</h6>
                        <span className="icon"> {activeIndex === currentIndex ? "−" : "+"}</span>
                    </div>
                    {/* Answer */}
                    {activeIndex === currentIndex && (
                        <div className="faq-answer"> <p>{faq.answer}</p> </div>
                    )}
                </div>
            );
        });

    return (
        <section className="faq-section container">
            <div className="row">
                {/* Left Column */}
                <div className="col-lg-6">{renderFaqs(leftFaqs, 0)}</div>
                {/* Right Column */}
                <div className="col-lg-6">{renderFaqs(rightFaqs, 5)}</div>
            </div>
        </section>
    );
}
